export class SchemaRegistrySubjectsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subjects",
            "baseName": "subjects",
            "type": "Array<SchemaRegistrySubject>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistrySubjectsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
